var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AvailAbilityStep } from "@common/enums/availability";
import { StepType } from "@common/enums/base";
export var ProgressBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, progressStore = _a.progressStore, problemStore = _a.problemStore, detailStore = _a.detailStore, questionsStore = _a.questionsStore, availabilityStore = _a.availabilityStore, homeStore = _a.homeStore, reviewStore = _a.reviewStore, recallCheckStore = _a.recallCheckStore, commonStore = _a.commonStore;
    var propsConnect = {
        step: progressStore.step,
        steps: progressStore.steps,
        currentStep: progressStore.step,
        currentUser: homeStore.currentUser,
        level: problemStore.level,
        progressLastLevel: problemStore.lastLevel,
        showDisclaimer: reviewStore.showDisclaimer,
        woTypeId: commonStore.woTypeId,
        serviceCodeWOType: problemStore.serviceCodeWOType,
        isRecallCheck: commonStore.isRecallCheck,
        recallWOList: recallCheckStore.recallWOList,
    };
    var dispatchConnect = {
        next: function () { return progressStore.next(); },
        back: function () {
            switch (progressStore.step) {
                case StepType.Detail:
                    problemStore.browserBack();
                    questionsStore.clearTroubleshootingAnswers();
                    availabilityStore.clear();
                    reviewStore.clear();
                    progressStore.back();
                    break;
                case StepType.Review:
                    if (!reviewStore.showDisclaimer) {
                        reviewStore.setDisclaimerData(true);
                        reviewStore.setTargetDisclaimer(true);
                    }
                    else {
                        availabilityStore.setParams('availabilityStep', AvailAbilityStep.AvailabilityIndex);
                        progressStore.back();
                    }
                    break;
                case StepType.Question:
                    if (questionsStore.residentResponsibilityVisible) {
                        questionsStore.setResidentResponsibilityVisible(false);
                    }
                    else {
                        progressStore.back();
                    }
                    break;
                default:
                    progressStore.back();
            }
        },
        initAll: function () {
            progressStore.jump(StepType.Problem);
            detailStore.clear();
            problemStore.clear();
            questionsStore.clear();
            availabilityStore.clear();
            reviewStore.clear();
            commonStore.clear();
        },
        jump: function (step) {
            progressStore.jump(step);
            if (progressStore.step === StepType.Problem) {
                problemStore.clear();
                questionsStore.clearTroubleshootingAnswers();
                availabilityStore.clear();
                reviewStore.clear();
            }
            if (!reviewStore.showDisclaimer) {
                reviewStore.setDisclaimerData(true);
                reviewStore.setTargetDisclaimer(false);
            }
            if (questionsStore.residentResponsibilityVisible && step !== StepType.Availability) {
                questionsStore.setResidentResponsibilityVisible(false);
            }
        },
        toJump: progressStore.jump,
        setLevel: function (level) {
            problemStore.setProblemLevel(level);
            problemStore.backLevelQuestion(level);
        },
        setHowToVideoVisibleProgress: problemStore.setHowToVideoVisible,
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
